import { connect } from "react-redux";
import dayjs from "dayjs";
import { Button } from "primereact/button";

import "./preview-certificate.scss";

const PreviewCertificate = ({
  url,
  user,
  learningName = "Learning Program name",
  dateofCompletion = new Date(),
  orientation = "portrait",
  isActual = false,
  enterprise,
  selectedCertificate,
}) => {
  const name = `${user.firstName} ${user.lastName ? ` ${user.lastName}` : ""}`;
  const { logo } = enterprise;

  const downloadCertificate = () => {
    window.print();
  };

  return (
    <div className="edexlms-certificate" id="edexlms_certificate">
      <img
        className={`cert-image ${orientation}`}
        src={`${new URL(url, process.env.REACT_APP_URL).toString()}?v=${
          selectedCertificate?.updatedAt || process.env.REACT_APP_VERSION
        }`}
        alt="certificate"
      />
      <div className={`edexlms-certificate-${orientation}`}>
        <div className="cert-logo">
          <img
            src={`${new URL(logo, process.env.REACT_APP_URL).toString()}`}
            alt="Logo"
            className="logo"
          />
        </div>
        <div className="cert-name">{name}</div>
        <div className="cert-program">{learningName}</div>
        <div className="cert-date">
          {dayjs(dateofCompletion).format("DD MMM YYYY")}
        </div>
      </div>
      {(isActual && (
        <div className="cert-download no-print">
          <Button
            icon="pi pi-arrow-circle-down"
            onClick={downloadCertificate}
            outlined
          ></Button>
        </div>
      )) ||
        null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.self?.user,
  enterprise: state?.global?.enterprise,
});

export default connect(mapStateToProps)(PreviewCertificate);
